import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";

interface ViewLinkProps {
    navigation: string;
}

const ViewLink: React.FC<ViewLinkProps> = ({ navigation }) => {
    const { t } = useTranslation();
    return (
        <Col xs={8} sm={5} xxl={4} className="mt-3 mt-xl-auto">
            <Link to={navigation} className="btn btn-outline-primary w-100 lh-sm py-2 px-1 px-xxl-4">
                {t("View")}
            </Link>
        </Col>
    );
};

export default ViewLink;
